module.exports = __webpack_public_path__ + "img/e6c6118e0a034e7d9d0b424f7a1da89e.e0055f08.png";